import React from 'react'
import PropTypes from 'prop-types'

import {
  IconButton,
  Tooltip,
} from '@material-ui/core/'

class TooltipIconButton extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    tooltipTitle: PropTypes.node,
  }

  static defaultProps = {
    tooltipTitle: '',
  }

  render() {
    const { children, tooltipTitle, ...props } = this.props

    return (
      <Tooltip title={tooltipTitle} disableFocusListener>
        <IconButton {...props}>
          { children }
        </IconButton>
      </Tooltip>
    )
  }
}

export default TooltipIconButton
